<div class="agpr-theme">
    <section
        class="agpr-theme-sidebar"
        [attr.aria-label]="'Common.layout.lhp' | localize"
    >
        <agpr-theme-sidebar></agpr-theme-sidebar>
    </section>
    <main
        class="agpr-theme-content" [agprLoading]="!socialRouteModel"
    >
        <router-outlet
            (deactivate)="onDeactivateComponent($event)"
            (activate)="onActivateComponent($event)"
        ></router-outlet>
    </main>
</div>
